import React, { useState, Context, ReactElement, Component } from "react";

export interface cluster_info_type {
    namespace: string;
    node: string;
    totalRootfs: string;
    totalCPU: string;
    totalMemory: string;
    totalPod: string;
    totalDisk: string;
    usedRootfs: string;
    usedCPU: string;
    usedMemory: string;
    usedPod: string;
    usedDisk: string;
    user: string;
    version: string;
    workspace: string;
    total_str: string;
    used: number;
    total: number;
    updateTime: string;
    display: (string | number | undefined)[];
    usedGPU: string;
    totalGPU: string;
}

const ClusterInfoContext: Context<[cluster_info_type, React.Dispatch<React.SetStateAction<cluster_info_type>>]> = React.createContext<[cluster_info_type, React.Dispatch<React.SetStateAction<cluster_info_type>>]>([{} as unknown as cluster_info_type, (_value: any) => { }]);

const ClusterInfoProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [cluster_info, set_cluster_info]: [cluster_info_type, React.Dispatch<React.SetStateAction<cluster_info_type>>] = useState({
        display: new Array(25).fill(undefined)
    } as unknown as cluster_info_type);
    return (
        <ClusterInfoContext.Provider value={[cluster_info, set_cluster_info]}>
            {props.children}
        </ClusterInfoContext.Provider>
    )
}

export { ClusterInfoContext, ClusterInfoProvider };

